import { render, staticRenderFns } from "./Navbars.vue?vue&type=template&id=3c87d19d&"
import script from "./Navbars.vue?vue&type=script&lang=js&"
export * from "./Navbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports